/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Per_TransactionInputs */

const en_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per transaction`)
};

const es_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por transacción`)
};

const fr_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par transaction`)
};

const de_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Transaktion`)
};

const ja_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 取引あたり`)
};

const zh_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每笔交易`)
};

const ar_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لكل معاملة`)
};

const id_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per transaksi`)
};

const it_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per transazione`)
};

const ru_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за транзакцию`)
};

const pt_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por transação`)
};

const ko_per_transaction = /** @type {(inputs: Per_TransactionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`건당`)
};

/**
* | output |
* | --- |
* | "per transaction" |
*
* @param {Per_TransactionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const per_transaction = /** @type {((inputs?: Per_TransactionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Per_TransactionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_per_transaction(inputs)
	if (locale === "es") return es_per_transaction(inputs)
	if (locale === "fr") return fr_per_transaction(inputs)
	if (locale === "de") return de_per_transaction(inputs)
	if (locale === "ja") return ja_per_transaction(inputs)
	if (locale === "zh") return zh_per_transaction(inputs)
	if (locale === "ar") return ar_per_transaction(inputs)
	if (locale === "id") return id_per_transaction(inputs)
	if (locale === "it") return it_per_transaction(inputs)
	if (locale === "ru") return ru_per_transaction(inputs)
	if (locale === "pt") return pt_per_transaction(inputs)
	return ko_per_transaction(inputs)
});